import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexDocumentsRequest = ({
  dispatch,
  params,
  successCallback,
  callback,
  failureCallback,
  format,
  responseType
}) =>
  ApiService.request('get', `/documents${format}`, {
    dispatch,
    params,
    successCallback,
    failureCallback,
    responseType: responseType || 'json',
    callback
  });

export const showDocumentPreviewRequest = (id, { employeeId, dispatch, params, failureCallback, successCallback }) =>
  ApiService.request('get', `/employees/${employeeId}/documents/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const publicShowDocumentPreviewRequest = (id, { dispatch, params, failureCallback, successCallback }) =>
  ApiService.request('get', `/public/documents/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const updateDocumentRequest = (id, { employeeId, dispatch, params, callback, successCallback }) =>
  ApiService.request('put', `/employees/${employeeId}/documents/${id}`, {
    dispatch,
    params,
    callback,
    successCallback
  });

export const downloadAllEmployeeDocumentsRequest = ({
  employeeId,
  dispatch,
  params,
  successCallback,
  failureCallback
}) =>
  ApiService.request('post', `/employees/${employeeId}/documents/export_all_documents`, {
    dispatch,
    params,
    successCallback,
    failureCallback
  });

export const debounceIndexDocumentsRequest = AwesomeDebouncePromise(indexDocumentsRequest, 300);
